
document.addEventListener("DOMContentLoaded", function () {
  // Find all product cards
  const productCards = document.querySelectorAll('.product-card-wrapper');

  productCards.forEach(function(card) {
    // Step 1: Find the correct product title link (deepest one)
    const titleLink = card.querySelector('.card__content .card__heading a');

    // Step 2: Find the <a> tag that wraps the image
    const imageWrapperLink = card.querySelector('.card__media > a');

    // Step 3: If both exist, set the image link's href to match the title's
    if (titleLink && imageWrapperLink) {
      const url = titleLink.getAttribute('href');
      imageWrapperLink.setAttribute('href', url);
    }
  });
});


  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".footer-block__details-content");
    const img = container.querySelector("img");

    // Create a new <a> element
    const link = document.createElement("a");
    link.href = "https://therubberpeople.com.au"; // Replace with your desired URL
    link.target = "_blank"; // Optional: open link in a new tab

    // Move the image into the link
    container.insertBefore(link, img);
    link.appendChild(img);
  });

  document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(() => {
    const checkbox = document.getElementById("marketing_opt_in");
    if (checkbox) {
      checkbox.checked = true; // check by default
      observer.disconnect();   // allow user to uncheck
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('click', function(e) {
  // Only target the quick-add / Buy Now buttons
  if (e.target.closest('.quick-add__submit') && e.target.closest('.related-products')) {
    e.preventDefault();

    // Find the product card wrapper
    const productCard = e.target.closest('.card-wrapper.product-card-wrapper');
    if (!productCard) return;

    // Find the product link inside the same card wrapper
    const productLink = productCard.querySelector('a[href*="/products/"]');

    // If found, redirect to its respective product page
    if (productLink && productLink.href) {
      window.location.href = productLink.href;
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
    const phoneInputs = document.querySelectorAll('input[type="number"]');

    phoneInputs.forEach(phoneInput => {
        // Create error message span
        let errorSpan = document.createElement('span');
        errorSpan.style.color = 'red';
        errorSpan.style.fontSize = '13px';
        errorSpan.style.display = 'block';
        errorSpan.style.marginTop = '5px';
        phoneInput.insertAdjacentElement('afterend', errorSpan); // Place after input

        phoneInput.addEventListener('input', function () {
            const originalValue = this.value;
            const sanitizedValue = originalValue.replace(/[^\d]/g, '');

            if (originalValue !== sanitizedValue) {
                errorSpan.textContent = "Invalid character. Only numbers are allowed.";
            } else {
                errorSpan.textContent = "";
            }

            this.value = sanitizedValue;

            if (this.value.length > 10) {
                this.value = this.value.slice(0, 10);
            }
        });

        phoneInput.addEventListener('blur', function () {
            if (this.value.length > 0 && this.value.length < 10) {
                errorSpan.textContent = "Phone number must be exactly 10 digits.";
            } else if (this.value.length === 10) {
                errorSpan.textContent = "";
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const emailInputs = document.querySelectorAll('input[type="email"]');

    emailInputs.forEach(emailInput => {
        let emailErrorSpan = document.createElement('span');
        emailErrorSpan.classList.add('email-error');
        emailErrorSpan.style.display = 'none'; 
        emailInput.parentNode.appendChild(emailErrorSpan);

        // Allowed characters for email
        const allowedChars = /^[a-zA-Z0-9._%+\-@]*$/;

        // Prevent typing invalid characters
        emailInput.addEventListener('beforeinput', function (e) {
            if (e.data && !allowedChars.test(e.data)) {
                e.preventDefault(); // block the input
                emailErrorSpan.textContent = "Invalid character for email address.";
                emailErrorSpan.style.display = 'block';
            }
        });

        // Validate full email on input
        emailInput.addEventListener('input', function () {
            const emailPattern = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if (this.value && !emailPattern.test(this.value)) {
                emailErrorSpan.textContent = "Please enter a valid email address.";
                emailErrorSpan.style.display = 'block';
            } else {
                emailErrorSpan.textContent = "";
                emailErrorSpan.style.display = 'none';
            }
        });
    });
});





  function validateName(input) {
    const regex = /^[a-zA-Z ]*$/;
    const errorEl = document.getElementById('name-error');

    if (!regex.test(input.value)) {
      errorEl.style.display = 'block';
    } else {
      errorEl.style.display = 'none';
    }

    // Always clean the input (already in your original code)
    input.value = input.value.replace(/[^a-zA-Z ]/g, '');
  }








